import React, { PropsWithChildren } from 'react';
import ObjectLink from 'components/ui/ObjectLink';
import { useRealtimeDocument } from 'hooks';
import type { IObject } from 'models';
import { GoToPageBehaviorData } from '../../../admin-bridge/CTAEditorModal/utils';
import { useSelector } from 'react-redux';
import { isEditMode } from 'services/admin';

interface GoToPageProps extends PropsWithChildren {
  pageId: string;
}

const GoToPage: React.FC<GoToPageProps> = ({ children, pageId }) => {
  const isEditing = useSelector(isEditMode);
  const [page, loaded] = useRealtimeDocument<IObject>('objects', pageId);

  if (!loaded || !page || isEditing) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <ObjectLink collection="pages" slug={page.slug}>
      {children}
    </ObjectLink>
  );
};

export default GoToPage;
